module.exports = __webpack_public_path__ + "img/download-3-4.db56bb24.png";